"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import * as n from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
import { Range as o, Root as s, Thumb as c, Track as l } from "@radix-ui/react-slider";
//#region src/components/atoms/Slider/Slider.tsx
var u = a("", { variants: { variant: {
	light: "bg-white",
	dark: "bg-gray-800"
} } }), d = ({ className: a, defaultValue: d, value: f, min: p = 0, max: m = 100, variant: h = "dark", trackProps: g = {}, thumbProps: _ = {}, rangeProps: v = {}, ...y }) => {
	let b = n.useMemo(() => Array.isArray(f) ? f : Array.isArray(d) ? d : [p, m], [
		f,
		d,
		p,
		m
	]);
	return /* @__PURE__ */ i(s, {
		"data-slot": "slider",
		defaultValue: d,
		value: f,
		min: p,
		max: m,
		className: e(["relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", a]),
		...y,
		children: [/* @__PURE__ */ r(l, {
			"data-slot": "slider-track",
			...g,
			className: e("bg-gray-400 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1", g?.className || ""),
			children: /* @__PURE__ */ r(o, {
				"data-slot": "slider-range",
				...v,
				className: e("absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full", u({ variant: h }), v?.className || "")
			})
		}), Array.from({ length: b.length }, (n, i) => /* @__PURE__ */ r(c, {
			"data-slot": "slider-thumb",
			"aria-label": `slider-thumb-${i + 1}`,
			..._,
			className: e("border-primary bg-background ring-ring/50 block relative size-5 before:absolute before:inset-[-2px] before:content-[''] shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-5 disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer", t(), _?.className || "")
		}, i))]
	});
};
//#endregion
export { d as Slider };
